import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';
import { hideLoader, showLoader } from '../../store/common/slice';
import { getUserProfile } from '../../store/auth/actions';
import Logo from '../../images/logo.svg';
import { getBase64 } from '../shared/statelessMethods';
import { PrintSection } from './PdfWrapperNew.styled';

const PdfWrapperNew = ({ container, onSavePdf }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const pdf = useRef();
    const userProfile = useSelector(state => state.auth.userProfile);
    const [partnerLogo, setPartnerLogo] = useState('');

    useEffect(async () => {
        dispatch(showLoader());
        if (userProfile.userID === undefined) await dispatch(getUserProfile());
        dispatch(hideLoader());
    }, [container, userProfile]);

    useEffect(async () => {
        if (userProfile?.userID) {
            const image = await getBase64(userProfile.partnerLogo || '');
            setPartnerLogo(`${image ? `data:image/png;base64,${image}` : ''}`);
            await onSavePdf(pdf.current);
        }
    }, [userProfile]);

    return (
        <PrintSection>
            <div ref={pdf} className='table-container'>
                <div className='logos'>
                    <div className='logo-top'>
                        <img src={Logo} alt="company logo" />
                    </div>
                    <div className={`logo-top partner ${partnerLogo ? '' : 'empty'}`}>
                        <img src={partnerLogo} alt="partner logo" />
                    </div>
                </div>
                {ReactHtmlParser(container.innerHTML)}            
            </div>
        </PrintSection>
    );
}

export default PdfWrapperNew;